export default "__VITE_ASSET__DY5$2mw___"